import React from 'react';
import './LeftDrawerFooter.css';
import RegionSelector from '../../../../widgets/region-selector/region-selector';
import { isAdminMode } from '../../../../../utils/session-util';
import { getRegionalColors } from '../../../../../utils/regional-colors';
const LeftDrawerFooter = (props) => (
  <div
    style={{
      backgroundColor: getRegionalColors().backgroundColor
    }}
  >
    {props.regionSelectionEnabled === 'true' && isAdminMode() ? (
      <RegionSelector
        style={{ padding: '4px 0 0 15px' }}
        onChangeRegion={() => window.location.reload()}
      />
    ) : null}
    <h6 className="footer">{props.text}</h6>
  </div>
);

export default LeftDrawerFooter;
